import { memo } from "react";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import SoftBox from "components/SoftBox";

const ButtonsWrapper = styled(SoftBox)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1),
  justifyContent: { xs: "space-evenly", xl: "flex-start" }
}));

const ViewButton = memo(({ icon, title, isActive, action }) => {
  return (
    <Tooltip title={title} placement="top">
      <IconButton
        className={isActive ? "active" : ""}
        variant="text"
        size="medium"
        color="text"
        sx={{
          color: isActive && "rgba(60, 63, 69, 0.76)",
          backgroundColor: isActive && "#C7CCD0",
          borderRadius: "10px"
        }}
        onClick={action}
      >
        <Icon>{icon}</Icon>
      </IconButton>
    </Tooltip>
  );
});

const VIEWS = {
  LIST: "list",
  TILES: "tiles",
  CALENDAR: "calendar"
};

function View({ setTableView, tableView, withCalendarView }) {
  const isActive = (view) => tableView === view;

  return (
    <ButtonsWrapper className="table-view-buttons">
      <ViewButton
        title="List View"
        icon="view_list_icon"
        isActive={isActive(VIEWS.LIST)}
        action={() => setTableView(VIEWS.LIST)}
      />
      <ViewButton
        title="Tiles View"
        icon="apps_icon"
        isActive={isActive(VIEWS.TILES)}
        action={() => setTableView(VIEWS.TILES)}
      />
      {withCalendarView && (
        <ViewButton
          title="Calendar View"
          icon="calendar_month_icon"
          isActive={isActive(VIEWS.CALENDAR)}
          action={() => setTableView(VIEWS.CALENDAR)}
        />
      )}
    </ButtonsWrapper>
  );
}

View.propTypes = {
  setTableView: PropTypes.func,
  tableView: PropTypes.string
};

export default memo(View);
